import { render, staticRenderFns } from "./ReplacedChemical.vue?vue&type=template&id=b4510bdc"
import script from "./ReplacedChemical.vue?vue&type=script&setup=true&lang=js"
export * from "./ReplacedChemical.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports